import React from 'react';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M4 10.5L7.94722 6.14635C7.96382 6.12799 7.9771 6.10546 7.9862 6.08023C7.9953 6.055 8 6.02766 8 6C8 5.97234 7.9953 5.945 7.9862 5.91977C7.9771 5.89454 7.96382 5.87201 7.94722 5.85365L4 1.5"
      stroke="#0862C0"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
